import { render, staticRenderFns } from "./ViewProject.vue?vue&type=template&id=08b17010"
import script from "./ViewProject.vue?vue&type=script&lang=js"
export * from "./ViewProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports